import { Box } from "@mui/material";
import CustomButton from "components/common/CustomButton";
import FileSearch from "components/fileStorage/FileSearch";
import type { PlatformEnumOption } from "features/integrationsBeta/enumLabel";
import DateRangeSelect, {
  FILTER_BAR_PHONE_SX,
  FILTER_FIELD_W,
  PAST_PRESETS,
} from "./DateRangeSelect";
import FilterSelect from "./FilterSelect";

export interface StepsFilters {
  search?: string;
  stage?: string;
  status?: string;
  started_after?: string;
  started_before?: string;
  finished_after?: string;
  finished_before?: string;
}

interface Props {
  filters: StepsFilters;
  onChange: (filters: StepsFilters) => void;
  stages: PlatformEnumOption[];
  statuses: PlatformEnumOption[];
}

export default function StepsFilterBar({
  filters,
  onChange,
  stages,
  statuses,
}: Props) {
  const set = (patch: Partial<StepsFilters>) =>
    onChange({ ...filters, ...patch });

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
        alignItems: "center",
        ...FILTER_BAR_PHONE_SX,
        mb: 1.5,
        flexShrink: 0,
      }}
    >
      <Box sx={{ width: FILTER_FIELD_W }}>
        <FileSearch
          onSearch={(term) => set({ search: term || undefined })}
          label="Search"
          size="small"
          initialValue={filters.search ?? ""}
          fullWidth
        />
      </Box>
      <FilterSelect
        label="Stage"
        value={filters.stage ?? ""}
        options={stages}
        onChange={(v) => set({ stage: v || undefined })}
      />
      <FilterSelect
        label="Status"
        value={filters.status ?? ""}
        options={statuses}
        onChange={(v) => set({ status: v || undefined })}
      />
      <DateRangeSelect
        label="Started"
        presets={PAST_PRESETS}
        value={{ after: filters.started_after, before: filters.started_before }}
        onChange={(r) =>
          set({ started_after: r.after, started_before: r.before })
        }
      />
      <DateRangeSelect
        label="Finished"
        presets={PAST_PRESETS}
        value={{
          after: filters.finished_after,
          before: filters.finished_before,
        }}
        onChange={(r) =>
          set({ finished_after: r.after, finished_before: r.before })
        }
      />

      <CustomButton fullWidth={false} onClick={() => onChange({})}>
        Clear Filters
      </CustomButton>
    </Box>
  );
}
